<template>
	<div class="homeFrame">
		<div class="homemask" v-show="isCreate || isChange || proChange || apply || isvideo"></div>
		<homehead ref="homehead" @showcus="showcus"></homehead>
		<div class="contentFrame">
			<homeleft ref="homeleft" @opencteate="opencteate" @openpaylog="openpaylog" @menuclick="menuclick" @showapply="showapply" @isout="isout" @openvideo="openvideo"></homeleft>
			<div class="contentRight" v-if="rightActive == 'mypro'">
				<div class="homeAd"><img src="../../assets/homeAdbg.jpg" style="width:100%"></div>
				<div class="listFrame">
					<div v-for="(item, index) in projectList" class="list" @mouseover="hoverlist(index)"
						@mouseout="hoverlistOut(index)">
						<div class="listPic">
							<img :src="headurl + item.template_img" :onerror="defaultImg" style="width: 100%;">
						</div>
						<div class="listInfo">
							<div class="listname">{{ item.name }}</div>
							<div class="listVersion" v-if="istimeout">
								<div class="listico2"></div>
								<div class="versionname">已过期</div>
							</div>
						</div>
						<div class="listhover" v-show="item.listhover">
							<div class="listmenuIcon">
								<!-- <div @click="preview()"><img src="../../assets/icon5.png" title="数据中心" alt="数据中心"></div> -->
								<!-- <div><img src="../../assets/icon6.png" title="复制项目" alt="复制项目"></div> -->
								<!-- <div><img src="../../assets/icon7.png" title="源代码下载" alt="源代码下载"></div> -->
								<div @click="sharepro(item)"><img src="../../assets/icon8.png" title="大屏分享"
										alt="大屏分享"></div>
								<div @click="deleteProject(item)"><img src="../../assets/icon9.png" title="删除" alt="删除">
								</div>
							</div>
							<div class="listManage">
								<div style="cursor:pointer" @click="goView(item)" class="listpreview">预览</div>
								<div style="cursor:pointer" @click="goEdit(item)" class="listEdit">编辑</div>
							</div>
							<div class="listnameedit">
								<div class="text" disabled>{{ item.name }}</div>
								<div @click="editTitle(item)"><img src="../../assets/edit.png" title="编辑标题"
										alt="编辑标题"></div>
							</div>
						</div>
					</div>
					<div class="nodata" v-if="!projectList.length">
						<img src="@/assets/nodata.png" alt="" class="nodata-img">
						暂无数据
					</div>
					<div class="page_bottom">
						<el-pagination background layout="prev, pager, next" :total="prototal" :page-size="8"
							@current-change="proPageChange" :current-page="pageindex" :small="true">
						</el-pagination>
					</div>
				</div>
			</div>
			<div class="contentRight" v-if="rightActive == 'mycomp'">
				<div class="homeAd"><img src="../../assets/homeAdbg.jpg" style="width:100%"></div>
				<div class="listFrame">
					<div v-for="(item, index) in zjList" class="list" @mouseover="hoverlist(index)"
						@mouseout="hoverlistOut(index)">
						<div class="listPic">
							<img :src="headurl + item.zujian_img" :onerror="defaultImg" style="width: 100%;">
						</div>
						<div class="listInfo">
							<div class="listname">{{ item.name }}</div>
							<div class="listVersion">
								<div class="listico1"></div>
								<div class="versionname">我的组件</div>
							</div>
						</div>
						<div class="listhover hovercenter" v-show="item.listhover">
							<div class="hovergroup">
								<div style="cursor:pointer" @click="changename(item)" class="listEdit">编辑</div>
								<div @click="deleteZj(item)" style="cursor:pointer"><img src="../../assets/icon9.png"
										title="删除" alt="删除"></div>
							</div>
						</div>
					</div>
					<div class="nodata" v-if="!zjList.length">
						<img src="@/assets/nodata.png" alt="" class="nodata-img">
						暂无数据
					</div>
					<div class="page_bottom">
						<el-pagination background layout="prev, pager, next" :total="total" :page-size="8"
							@current-change="componentPageChange" :current-page="pageindex" :small="true">
						</el-pagination>
					</div>
				</div>
			</div>
		</div>
		<div class="createWin" v-show="isCreate">
			<div class="createNew">
				<div class="createNewName">创建新项目</div>
				<div class="createClose" @click="closecreate">
					<img src="../../assets/close.png" style="width: 100%;">
				</div>
			</div>
			<div class="createFrame">
				<div class="createLeft">
					<div class="createDemo">
						<img v-if="!formData.image" src="../../assets/createbg.png">
						<img v-if="formData.image" :src="headurl + formData.image">
					</div>
					<div class="demoTitle">通用大屏示例</div>
					<div class="demoSubtitle">包含通用模板，通用组件，适合于各行业基础的数据分析与展示</div>
					<div class="demoLine"></div>
					<div class="caseName">项目名称：</div>
					<div class="caseTitleInput">
						<input v-model="formData.title" type="text" autofocus="autofocus" />
					</div>
					<div class="createbutton">
						<button class="createNewTitle" @click="createNow">创建项目</button>
						<button class="createover" @click="closecreate">取消</button>
					</div>
				</div>
				<div class="createRight">
					<div class="creatModelMenu">
						<div :class="modelclass" @click="model()">通用模板</div>
						<div :class="modelclass1" @click="modelVip()">定制模板</div>
						<!-- <div :class="modelclass2" @click="modelDiy()">定制模板</div> -->
						<div class="modelLine" :style="{ left: leftmove }"></div>
					</div>
					<div class="modelContent">
						<div v-for="(item, index) in templateList"
							:class="selectedTemplateId.id == item.id ? 'model_cur' : 'model'">
							<div @click="selectTemplate(item)" class="modelPic">
								<img :src="headurl + item.pic_path" :onerror="defaultImg" style="width: 100%;">
							</div>
							<div class="modelTitle">
								<div>{{ item.name }}</div>
							</div>
						</div>
					</div>
					<div class="nodata" v-if="!mbtotal">
						<img src="@/assets/nodata.png" alt="" class="nodata-img">
						暂无数据
					</div>
					<div class="page_bottom">
						<el-pagination background layout="prev, pager, next" :total="mbtotal" :page-size="6"
							@current-change="mobChange" :current-page="mobindex" :small="true">
						</el-pagination>
					</div>
				</div>
			</div>
		</div>
		<div class="changename" v-if="isChange">
			<div class="changeTop">
				<div class="createNewName">编辑组件名称</div>
				<div class="createClose" @click="closeChange">
					<img src="../../assets/close.png" style="width: 100%;">
				</div>
			</div>
			<div class="changeBtm">
				组件名称：
				<el-input v-model="selectData.name" class="change-input" type="text" placeholder="请输入组件名称"></el-input>
			</div>
			<div class="change-group">
				<el-button type="primary" @click="update" size="small">确认</el-button>
				<el-button type="info" @click="closeChange" size="small">取消</el-button>
			</div>
		</div>
		<div class="changename" v-if="proChange">
			<div class="changeTop">
				<div class="createNewName">编辑项目名称</div>
				<div class="createClose" @click="closeProName">
					<img src="../../assets/close.png" style="width: 100%;">
				</div>
			</div>
			<div class="changeBtm">
				项目名称：
				<el-input v-model="prodata.name" class="change-input" type="text" placeholder="请输入项目名称" maxlength="15"></el-input>
			</div>
			<div class="change-group">
				<el-button type="primary" @click="updatePro" size="small">确认</el-button>
				<el-button type="info" @click="closeProName" size="small">取消</el-button>
			</div>
		</div>
		<div v-show="apply" class="apply-content">
			<div class="apply-top">
				<div class="apply-title">申请试用</div>
				<div class="createClose" @click="closeApply">
					<img src="../../assets/close.png" style="width: 100%;">
				</div>
			</div>
			<div class="apply-title2">
				专业顾问将于24小时内与您联系，为您开放个人版专属权益
			</div>
			<div class="apply-item" v-for="item in applylist">
				<div class="apply-title3">{{ item.name }} <em v-if="item.extand">({{ item.extand }})</em></div>
				<el-input v-model="item.value" type="text" :placeholder="`请输入${item.name}`"/>
			</div>
			<el-button type="primary" size="small" class="up-btn" @click="upapply">立即提交</el-button>
		</div>
		<div class="example-video" v-if="isvideo">
			<div class="apply-close" @click="closevideo">
				<img src="../../assets/close.png" style="width: 100%;">
			</div>
			<video ref="videoRef" src="@/assets/example.mp4" type="video/mp4" :controls="isvideo" muted
                    :autoplay="isvideo" loop></video>
		</div>
		<paylog :payvisible="payvisible" :iscustom="iscustom" @payclose="payclose" @updatainfo="updatainfo"></paylog>
		<sharelog :link="sharelink" :showlink="showshare" @shareclose="shareclose" :proId="shareid" :pwd="pwd"></sharelog>
	</div>
</template>

<script>
import homehead from '../../components/header.vue'
import screenfull from 'screenfull';
import { Message } from 'element-ui';
import router from '@/router';
import { getprolist, gettemplist, addpro, delete_pro, getMyComp, userZjdel, updateZjName, update_proname, userapply } from '@/api/new'
import homeleft from '@/components/homeleft.vue'
import paylog from '@/components/paylog.vue'
import sharelog from '@/components/sharelog.vue'

export default {
	components: {
		homehead,
		homeleft,
		paylog,
		sharelog
	},
	data() {
		return {
			defaultImg: 'this.src = "' + require('../../assets/imgerror.png') + '"', //默认图片的地址
			listhover: false,
			isCreate: false,
			leftmove: '4%',
			modelclass: 'modelclass modelclassSelected',
			modelclass1: 'modelclass1 modelclassSelect',
			modelclass2: 'modelclass1 modelclassSelect',
			fullscreen: false,
			userInfor: {},//用户信息
			templateList: [],//模板列表
			projectList: [],//项目列表
			selectedTemplateId: '',//选择的模板ID
			formData: {
				title: "",
				image: "",
			},
			headurl: process.env.VUE_APP_BASE_API,
			rightActive: 'mypro',
			pagesize: 8,
			pageindex: 1,
			total: 0,
			zjList: [],
			isChange: false,
			selectData: '',
			proChange: false,
			prodata: {},
			prototal: 0,
			payvisible: false,
			iscustm: false,
			mbtotal: 0,
			mobindex: 1,
			sharelink: '',
			showshare: false,
			apply: false,
			applylist: [
				{ name: '公司名称', key: 'company_name', value: '' },
				{ name: '手机号码', key: 'contact_tel', value: '', extand: '请确保能联系到您' },
				{ name: '联系人', key: 'contact_person', value: '' },
			],
			istimeout: false,
			isvideo: false,
			iscustom: false,
			shareid: '',
			pwd: ''
		}
	},
	mounted() {
		var token = localStorage.getItem("token");
		if (!token) {
			Message.warning("您还未登录！");
			router.push({ path: '/login' });
			return;
		}
		this.userInfor = localStorage.getItem("userInfor");
		if (!this.userInfor) {
			Message.warning("登录信息失效！");
			router.push({ path: '/login' });
			return;
		}
		if (localStorage.getItem("HomeState") == "0") {
			setTimeout(() => {
				window.location.reload();
				localStorage.setItem("HomeState", "");
			}, 300);
			return
		}
		this.userInfor = JSON.parse(this.userInfor);
		this.getProjectList();
		this.getTemplateList();
		// setTimeout(() => {
		// 	this.footerData1 = [
		// 		['合计', '2', '44', '67', '-', '1111', '322222', '45555']
		// 	]
		// 	console.log('_)))footerData1')
		// 	this.footerMethod1()
		// }, 10000);
	},
	methods: {
		deleteProject(item) {
			// if(item.id<=47){
			// 	Message.warning("该项目正在使用中,暂时不能删除!");
			// 	return;
			// }
			this.$confirm('是否删除该项目?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(async () => {
					var temp = { id: item.id }
					const res = await delete_pro(temp);
					if (res.status == -1) {
						this.$message.warning(res.msg);
						return;
					}
					this.$message({
						type: 'success',
						message: '删除成功!'
					})
					this.getProjectList();
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					})
				})
		},
		async goView(item) {
			if (!await this.getPermision(0)) {
				return;
			}
			const routeData = this.$router.resolve({
				name: 'editnew', // 目标路由的名称
				query: {
					projectId: item.id,
					preview: 1
				}
			});
			window.open(routeData.href, '_blank');
		},
		async sharepro(item) {
			if (!await this.getPermision(1)) {
				return;
			}
			const routeData = this.$router.resolve({
				name: 'share', // 目标路由的名称
				query: {
					projectId: item.ids,
					preview: 1,
				}
			});
			let href = window.location.origin + window.location.pathname
			this.sharelink = href + routeData.href
			this.shareid = item.id
			this.pwd = item.pwd
			this.showshare = true
			// window.open(routeData.href, '_blank');
		},
		shareclose() {
			this.showshare = false
		},
		async goEdit(item) {
			if (!await this.getPermision(0)) {
				return;
			}
			this.$router.push({ path: '/editnew', query: { projectId: item.id } });
		},
		getProjectList() {
			var _this = this;
			var params = { page: this.pageindex, limit: 8 }
			getprolist(params).then(res => {
				if (res.status != 200) {
					Message.warning(res.msg);
					return;
				}
				if (res.data) {
					this.prototal = res.count
					_this.projectList = res.data.map(item => {
						return {
							...item,
							listhover: false
						}
					})
				}
			});
		},
		selectTemplate(item) {
			this.selectedTemplateId = item;
			this.formData.image = item.pic_path;
			this.formData.title = item.name
		},
		getTemplateList() {
			var _this = this;
			var params = { page: this.mobindex, limit: 6, is_customized: this.iscustm ? 1 : 0 }
			gettemplist(params).then(res => {
				if (res.status != 200) {
					Message.warning(res.msg);
					return;
				}
				if (res.data) {
					_this.templateList = res.data
					this.mbtotal = res.count
				}
			});
		},
		//退出登录
		loginOut() {
			Message.success("退出登录成功！");
			localStorage.setItem("HomeState", "")
			localStorage.setItem("userInfor", "");
			localStorage.setItem("token", "");
			router.push({ path: '/login' });
		},
		hoverlist(index) {
			// 鼠标滑过时的逻辑
			// console.log('鼠标滑过');
			if (this.rightActive == 'mypro') {
				this.projectList[index].listhover = true;
			} else if (this.rightActive == 'mycomp') {
				this.zjList[index].listhover = true;
			}
			this.$forceUpdate();
		},
		hoverlistOut(index) {
			// 鼠标滑出时的逻辑
			// console.log('鼠标滑出')
			if (this.rightActive == 'mypro') {
				this.projectList[index].listhover = false;
			} else if (this.rightActive == 'mycomp') {
				this.zjList[index].listhover = false;
			}
			this.$forceUpdate();
		},
		preview() {
			alert("test")
		},
		async opencteate() {
			if (!await this.getPermision(0)) {
				return;
			}
			this.isCreate = true
		},
		menuclick(id) {
			this.pageindex = 1
			this.rightActive = id
			if (id == 'mycomp') {
				this.getMyComp()
			} else if (id == 'mypro') {
				this.getProjectList()
			}
		},
		closecreate() {
			this.isCreate = false
		},
		model() {
			this.iscustm = false
			this.getTemplateList()
			this.leftmove = "4%"
			this.modelclass = "modelclass modelclassSelected"
			this.modelclass1 = "modelclass1 modelclassSelect"
			this.modelclass2 = "modelclass1 modelclassSelect"
		},
		modelVip() {
			this.iscustm = true
			this.getTemplateList()
			this.leftmove = document.documentElement.clientWidth * 0.4277 * 0.1 + 56 + "px"
			this.modelclass = "modelclass modelclassSelect"
			this.modelclass1 = "modelclass1 modelclassSelected"
			this.modelclass2 = "modelclass1 modelclassSelect"
		},
		modelDiy() {
			this.iscustm = false
			this.leftmove = document.documentElement.clientWidth * 0.4277 * 0.16 + 112 + "px"
			this.modelclass = "modelclass modelclassSelect"
			this.modelclass1 = "modelclass1 modelclassSelect"
			this.modelclass2 = "modelclass1 modelclassSelected"
		},
		screen() {
			if (!screenfull.enabled) {
				return false
			}
			screenfull.toggle()
		},
		async createNow() {
			if (!await this.getPermision(0)) {
				return;
			}
			let tipslist = {
				0: '试用版用户仅可创建1个项目',
				1: '月费用户仅可创建10个项目',
				2: '年费用户仅可创建50个项目'
			}
			let tips = tipslist[this.userInfor.role_id]
			if (this.prototal > 49) {
				if (!await this.getPermision(3)) {
					Message.warning(tips)
					return
				}
			} else if (this.prototal > 9) {
				if (!await this.getPermision(2)) {
					Message.warning(tips)
					return
				}
			} else if (this.prototal > 0) {
				if (!await this.getPermision(1)) {
					Message.warning(tips)
					return
				}
			}
			if (!this.formData.title) {
				Message.warning("项目名称不能为空！");
				return;
			}
			if (!this.selectedTemplateId) {
				Message.warning("请选择右边的模板！");
				return;
			}
			var _this = this;
			var data = {
				name: _this.formData.title,
				template_id: parseInt(_this.selectedTemplateId.id),
				remarks: "",
			}
			addpro(data).then(res => {
				if (res.status != 200) {
					Message.warning(res.msg);
					return;
				}
				if (res.data) {
					this.screen();
					//this.$router.push({path:'/'});
					this.$router.push({ path: '/editnew', query: { projectId: res.data.id } });
				}
			})
		},
		// <我的组件方法>
		getMyComp() {
			const data = {
				page: this.pageindex,
				limit: this.pagesize
			}
			getMyComp(data).then(res => {
				this.total = res.count
				this.zjList = res.data
			})
		},
		deleteZj(item) {
			this.$confirm('是否删除该组件?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
			.then(async () => {
				var temp = { id: item.id }
				const res = await userZjdel(temp);
				if (res.status == -1) {
					this.$message.warning(res.msg);
					return;
				}
				this.$message({
					type: 'success',
					message: '删除成功!'
				})
				this.getMyComp();
			})
			.catch(() => {
				this.$message({
					type: 'info',
					message: '已取消删除'
				})
			})
		},
		async changename(item) {
			if (!await this.getPermision(2)) {
				return;
			}
			this.selectData = JSON.parse(JSON.stringify(item))
			this.isChange = true
		},
		closeChange() {
			this.isChange = false
		},
		update() {
			this.$confirm('是否修改组件名称?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
			.then(async () => {
				updateZjName(this.selectData).then(res => {
					this.closeChange()
					this.getMyComp()
					this.$message({
						type: 'success',
						message: '修改成功!'
					})
				})
			})
			.catch(() => { })
		},
		componentPageChange(e) {
			this.pageindex = e
			this.getMyComp()
		},
		proPageChange(e) {
			this.pageindex = e
			this.getProjectList()
		},
		async editTitle(item) {
			if (!await this.getPermision(0)) {
				return;
			}
			if (!item.title) {
				item.title = JSON.parse(JSON.stringify(item.name))
			}
			this.prodata = JSON.parse(JSON.stringify(item))
			this.proChange = true
		},
		closeProName() {
			this.proChange = false
		},
		updatePro() {
			let params = {
				id: this.prodata.id,
				name: this.prodata.name
			}
			update_proname(params).then(res => {
				if (res.status == 200) {
					this.proChange = false
					this.getProjectList()
				}
			})
		},
		// <我的组件方法 end>
		openpaylog() {
			this.payvisible = true
		},
		payclose() {
			this.payvisible = false
			this.iscustom = false
		},
		updatainfo() {
			let dom1 = this.$refs.homehead
			let dom2 = this.$refs.homeleft
			dom1.updateInfo()
			dom2.updateInfo()
		},
		// 模板翻页
		mobChange(e) {
			if (e == this.mobindex) return
			this.mobindex = e
			this.getTemplateList()
		},
		// 打开试用申请弹窗
		showapply() {
			this.apply = true
		},
		// 关闭试用申请弹窗
		closeApply() {
			this.apply = false
			location.reload()
		},
		// 手机号正则验证
		isPhone (phone) {
			const regex = /^(?:(?:\+|00)86)?1[3-9]\d{9}$/;
			return regex.test(phone);
		},
		// 提交试用申请
		upapply() {
			let params = {}
			let phone = ''
			this.applylist.forEach(item => {
				params[item.key] = item.value
				if (item.key == 'contact_tel') {
					phone = item.value
				}
			})
			let isphone = this.isPhone(phone)
			if (!isphone) {
				this.$message.warning('请输入正确的手机号')
				return
			}

			userapply(params).then(res => {
				if (res.status == 200) {
					alert('申请试用通过');
					this.closeApply()
				} else {
					this.$message.warning(res.msg)
				}
			})
		},
		// 用户会员已过期
		isout(userinfo) {
			this.istimeout = true
			this.userInfor = userinfo
		},
		// 打开示例视频
		openvideo() {
			this.isvideo = true
		},
		closevideo() {
			this.isvideo = false
		},
		// 打开定制的付款页
		showcus() {
			this.iscustom = true
			this.payvisible = true
		}
	},
}
</script>
<style scoped lang="scss">
.homeFrame {
	width: 100%;
	height: 100%;
	background: #181a1b;
	font-family: "Hei";
}



.contentFrame {
	width: 100%;
	display: flex;
}

.textS {
	color: #fff !important;
}

.myCaseS {
	background: url(../../assets/icon_1.png) no-repeat 15px center #2b2d32 !important;
	background-size: 16px !important;
	border-radius: 4px;
}

.myDiyS {
	background: url(../../assets/icon_2_1.png) no-repeat 15px center #2b2d32 !important;
	background-size: 16px !important;
	border-radius: 4px;
}

.wasterS {
	background: url(../../assets/icon_3_1.png) no-repeat 15px center #2b2d32 !important;
	background-size: 16px !important;
	border-radius: 4px;
}

.contentRight {
	width: 80%;
	height: 93vh;
	background: #181a1b;
}

.contentRight .listPic {
	width: 100%;
	background: url(../../assets/logoblack.jpg) no-repeat #1f1e1f center center;
	background-size: 137px;
	border-top-left-radius: 6px;
	border-top-right-radius: 6px;
	height: calc(100vw*0.8*0.97*0.23*0.5625);
}

.contentRight .homeAd {
	width: 97%;
	margin: 3vh auto 0 auto;
}

.contentRight .listFrame {
	width: 99%;
	justify-content: left;
	display: flex;
	flex-wrap: wrap;
	margin: 3vh auto;
}

.contentRight .list {
	width: 23%;
	text-align: center;
	margin: 0 1% 30px 1%;
	position: relative;
}

.contentRight .listversionName {
	position: absolute;
	top: 15px;
	right: 15px
}


.contentRight .listInfo {
	width: 100%;
	height: 50px;
	background: #27282c;
	border-bottom-left-radius: 6px;
	border-bottom-right-radius: 6px;
	display: flex;
	justify-content: space-between;
	line-height: 50px;

}

.contentRight .listname {
	color: #fff;
	font-size: 14px;
	margin: 0 0 0 5%;
	max-width: 90%;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

.contentRight .listVersion {
	display: flex;
	margin: 0 5% 0 0
}

.contentRight .listico1 {
	width: 4px;
	height: 4px;
	background: #01fe36;
	border-radius: 50%;
	margin: 22px 10px 0 0
}

.contentRight .listico2 {
	width: 4px;
	height: 4px;
	background: #ffa800;
	border-radius: 50%;
	margin: 22px 10px 0 0
}

.contentRight .versionname {
	font-size: 13px;
	color: #b3b3b3
}

.contentRight .listhover {
	width: 100%;
	height: 100%;
	background: rgba(0, 0, 0, .6);
	position: absolute;
	top: 0;
	left: 0;
	border-radius: 5px;
	border: 1px solid #3783f4;
	box-shadow: 0 0 15px #1963ea;
	backdrop-filter: blur(2px);
	animation: listhover 500ms linear 1;
	animation-fill-mode: forwards;
	opacity: 0;

	&.hovercenter {
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.hovergroup {
		margin: auto 0;
		display: flex;
		column-gap: 32px;
	}
}

@keyframes listhover {
	from {
		opacity: 0;
	}

	to {
		opacity: 1;
	}
}

.contentRight .listmenuIcon {
	display: flex;
	width: 30%;
	justify-content: space-between;
	margin: 20% auto 0 auto;
}

.contentRight .listmenuIcon img {
	width: 18px;
	cursor: pointer;
}

.contentRight .listManage {
	display: flex;
	margin: 20px auto 0 auto;
	width: 170px;
	justify-content: space-between;
}

.contentRight .listpreview {
	width: 80px;
	height: 37px;
	background: #28292a;
	border-radius: 8px;
	text-align: center;
	line-height: 37px;
	color: #fff;
	font-family: 'Hei';
	font-size: 14px;
}

.contentRight .listEdit {
	width: 80px;
	height: 37px;
	background: #3b89ff;
	border-radius: 8px;
	text-align: center;
	line-height: 37px;
	color: #fff;
	font-size: 14px;
}

.contentRight .listnameedit {
	width: 95%;
	position: absolute;
	bottom: 17px;
	left: 5%;
	display: flex;
	align-items: center;
	height: 18px;

	>div {
		height: 100%;
		display: flex;
		align-items: center;
	}

	img {
		width: 18px;
		height: 18px;
		cursor: pointer;
		margin-left: 12px;
	}
}

.contentRight .listnameedit .text {
	background: none;
	border: none;
	color: #fff;
	// width: 100%;
	font-size: 14px;
	line-height: 18px;
	outline: none;
	width: fit-content;
	cursor: default;
	max-width: 84%;
}


.createWin {
	position: absolute;
	width: 65%;
	height: 66vh;
	background: #181919;
	top: 17vh;
	left: 17.5%;
	box-shadow: 0 0 25px #000;
	transition: all 1s ease;
	animation: win 400ms linear 1;
	opacity: 0;
	animation-fill-mode: forwards;
	z-index: 2;
}

.changename {
	position: absolute;
	width: 25%;
	height: fit-content;
	background: #181919;
	top: 17vh;
	left: 37.5%;
	box-shadow: 0 0 25px #000;
	transition: all 1s ease;
	animation: win 400ms linear 1;
	opacity: 0;
	animation-fill-mode: forwards;
	z-index: 2;
}
.apply-content {
	position: absolute;
	width: 550px;
	height: fit-content;
	background: #181919;
	top: 17vh;
	left: calc(50% - 275px);
	box-shadow: 0 0 25px #000;
	transition: all 1s ease;
	animation: win 400ms linear 1;
	opacity: 0;
	animation-fill-mode: forwards;
	z-index: 2;
	padding: 34px;
	box-sizing: border-box;
	.apply-title {
		font-family: Source Han Sans CN;
		font-weight: 500;
		font-size: 18px;
		color: #FFFFFF;
		line-height: 18px;
	}
	.apply-title2 {
		font-family: Source Han Sans CN;
		font-weight: 400;
		font-size: 16px;
		color: #747474;
		line-height: 16px;
		margin-top: 24px;
	}
	.apply-title3 {
		font-family: Source Han Sans CN;
		font-weight: 500;
		font-size: 16px;
		color: #FFFFFF;
		line-height: 16px;
		em {
			color: #ccc;
		}
	}
	.apply-item {
		margin-top: 44px;
		& + .apply-item {
			margin-top: 24px;
		}
		.el-input {
			margin-top: 16px;
		}
	}
	.up-btn {
		margin: 34px auto 0;
		display: block;
	}
}

@keyframes win {
	from {
		opacity: 0;
	}

	to {
		opacity: 1;
	}
}

.createWin .createNew {
	width: 100%;
	height: 5vh;
	background: #121314;
	line-height: 5vh;
	color: #a8a8a8;
	font-size: 16px;
	display: flex;
	justify-content: space-between;
}

.createWin .createNewName {
	padding-left: 40px
}

.createWin .createClose {
	width: 20px;
	padding-right: 40px;

	img {
		cursor: pointer;
	}
}

.createWin .createFrame {
	display: flex;
	width: 100%;
	height: 60vh
}

.createWin .createLeft {
	width: 30%;
	height: 60vh;
	border-right: 1px solid #1f2121
}

.createWin .createDemo {
	width: 90%;
	height: calc(100vw*0.65*0.3*0.9*0.5625);
	/* background:url(../../assets/createbg.png) no-repeat center center #242627;
		margin:2vh 0 0 5%;border-radius:5px;background-size:30% */
	display: flex;
	align-items: center;
}

.createWin .createDemo img {
	display: block;
	width: auto;
	height: 90%;
	margin: 0 auto;
}

.createWin .demoTitle {
	color: #b8b8b8;
	font-size: 14px;
	margin: 2vh 0 0 5%
}

.createWin .demoSubtitle {
	color: #6b6c6d;
	margin: 1vh 0 0 5%;
	width: 90%;
	font-size: 13px;
}

.createWin .demoLine {
	width: 100%;
	height: 1px;
	background: #1f2121;
	margin: 3vh 0
}

.createWin .caseName {
	color: #a8a8a8;
	font-size: 14px;
	margin: 0 0 0 5%
}

.createWin .caseTitleInput {
	width: 86%;
	margin: 1vh 0 0 5%;
}

.createWin .caseTitleInput input {
	width: 100%;
	height: 40px;
	background: #1e1f23;
	border: 1px solid #323534;
	border-radius: 3px;
	outline: none;
	color: #a8a8a8;
	padding-left: 1em;
}

.createWin .createbutton {
	display: flex;
	margin: 3vh 0 0 5%;
}

.createWin .createNewTitle {
	background: #0a80fa;
	border: none;
	color: #fff;
	font-size: 14px;
	text-align: center;
	padding: 10px 5%;
	border-radius: 3px;
}

.createWin .createover {
	background: #292a2e;
	border: 2px solid #323534;
	color: #fff;
	font-size: 14px;
	text-align: center;
	padding: 10px 5%;
	border-radius: 3px;
	margin: 0 0 0 15px
}

.createWin .createRight {
	width: 70%;
}

.createWin .creatModelMenu {
	width: 100%;
	height: 5.5vh;
	border-bottom: 1px solid #1f2121;
	display: flex;
	line-height: 5.5vh;
	position: relative;
}

.createWin .modelclass {
	cursor: pointer;
	font-size: 14px;
	margin: 0 0 0 4%;
}

.createWin .modelclass1 {
	cursor: pointer;
	font-size: 14px;
	margin: 0 0 0 5.5%;
}

.createWin .modelclassSelected {
	color: #eee;
}

.createWin .modelclassSelect {
	color: #737373;
}

.createWin .modelLine {
	width: 56px;
	height: 2px;
	background: #0a80fa;
	position: absolute;
	bottom: 0;
	transition: all 1s ease;
}

.createWin .modelContent {
	width: 94%;
	display: flex;
	flex-wrap: wrap;
	justify-content: left;
	margin: 3vh 0 0 4%
}

.createWin .model {
	width: 30%;
	height: calc(100vw*0.65*0.7*0.3*0.94*0.5625 + 4vh + 2px);
	margin-right: 3%;
	margin-bottom: 20px;
	cursor: pointer;
}

.createWin .model:hover {
	width: calc(30% - 2px);
	height: calc(100vw*0.65*0.7*0.3*0.94*0.5625 + 4vh);
	border: 1px solid #3783f4;
	box-shadow: 0 0 15px #1963ea;
	border-radius: 5px;
}

.createWin .model_cur {
	width: calc(30% - 2px);
	height: calc(100vw*0.65*0.7*0.3*0.94*0.5625 + 4vh);
	border: 1px solid #3783f4;
	box-shadow: 0 0 15px #1963ea;
	border-radius: 5px;
	margin-right: 3%;
	cursor: pointer;
}

.createWin .modelPic {
	width: 100%;
	background: url(../../assets/logoblack.jpg) no-repeat #1f1e1f center center;
	background-size: 137px;
	border-top-left-radius: 6px;
	border-top-right-radius: 6px;
	height: calc(100vw*0.65*0.7*0.3*0.94*0.5625);
}

.createWin .modelPic img {
	border-top-left-radius: 6px;
	border-top-right-radius: 6px;
}

.createWin .modelTitle {
	width: 100%;
	height: 4vh;
	background: #27292c;
	border-bottom-left-radius: 6px;
	border-bottom-right-radius: 6px;
	display: flex;
	justify-content: space-between;
	line-height: 4vh;
}

.createWin .modelTitle div {
	color: #ecebec;
	font-size: 12px;
	padding-left: 15px;
	max-width: 100%;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.menuFrame div {
	transition: 0.5s;
}

.menuFrame div:hover {
	font-weight: bold;
	cursor: pointer;
}

.apply-top {
	width: 100%;
	display: flex;
	justify-content: space-between;
	img {
		width: 20px;
		height: 20px;
		cursor: pointer;
	}
}

.changeTop {
	width: 100%;
	height: 5vh;
	background: #121314;
	line-height: 5vh;
	color: #a8a8a8;
	font-size: 16px;
	display: flex;
	justify-content: space-between;
}

.changeTop .createNewName {
	padding-left: 40px
}

.changeTop .createClose {
	width: 20px;
	padding-right: 40px;

	img {
		width: 20px;
		height: 20px;
		cursor: pointer;
	}
}

.changeBtm {
	color: #fff;
	display: flex;
	align-items: center;
	padding: 0 24px;
	margin-top: 24px;
}

.change-input {
	margin-left: 12px;
	flex: 1;
}

.change-group {
	display: flex;
	align-items: center;
	justify-content: right;
	margin: 16px 24px 16px auto;
}

.nodata {
	width: calc(100% - 75px);
	display: flex;
	margin-bottom: 16px;
	flex-direction: column;
	text-align: center;
    font-size: 24px;
}

.nodata-img {
	width: 185px;
	height: 240px;
	margin: 60px auto 16px;
}
.homemask {
	position: absolute;
	width: 100%;
	height: 100%;
	left: 0;
	top: 0;
	background: rgba(0, 0, 0, .33);
	z-index: 1;
}
.example-video {
	position: absolute;
	width: 80%;
	height: 80%;
	left: 10%;
	top: 10%;
	z-index: 2;
	video {
		width: 100%;
		height: 100%;
	}
	.apply-close {
		width: 20px;
		position: absolute;
		right: 120px;
    	top: 20px;
		z-index: 2;
		img {
			width: 20px;
			height: 20px;
			cursor: pointer;
		}
	}
}
</style>
<style lang="scss">
.apply-content {
	.apply-item {
		.el-input__inner {
			background: #212226;
			border-radius: 4px;
			border: 1px solid #3A3B3C;
			color: #C0C0C0;
			&::-webkit-input-placeholder {
				color: #747474;
			}
		}
	}
}
</style>